import MyAccount from "../components/MyAccount";

const MyAccountContainer = () => {
    
    return <MyAccount/>
}

export default MyAccountContainer